import {api,ApiError} from '../../lib/api';
import {queryCache} from '../../lib/queryCache';

type Preparation={state:'ready'|'translating'};
/** The server checks the exact source version on every poll and again at freeze. */
export async function prepareArticlePublication(input:{articleId:string;resourceId:string;expectedUpdatedAt?:string;operationId:string},status:(text:string)=>void=()=>{}) {
 const epoch=queryCache.sessionEpoch,deadline=Date.now()+5*60_000;
 const checkAccess=()=>{if(epoch!==queryCache.sessionEpoch)throw new ApiError('forbidden','Adgangen er ændret. Hent artiklen igen.')};
 status('Kontrollerer slug og engelsk version…');
 let previousState:Preparation['state']|undefined;
 while(Date.now()<deadline){
  checkAccess();
  const result=await api<Preparation>('prepareArticlePublication',input);
  checkAccess();
  if(result.state!==previousState){queryCache.invalidate();previousState=result.state}
  if(result.state==='ready'){status('Engelsk er ajour. Indholdet låses nu.');return}
  status('Opdaterer engelsk ud fra dine seneste rettelser. Vent venligst…');
  await new Promise(resolve=>setTimeout(resolve,2000));
 }
 throw new ApiError('conflict','Engelsk er stadig under udarbejdelse. Intet er planlagt eller udgivet. Prøv igen, når skriveopgaven er færdig.');
}
